/**
 * The cropped region as a data URL.
 *
 * PNG by default, matching the canvas default: it is lossless and keeps transparency, which a caller
 * cropping a graphic rather than a photo relies on. Callers cropping photos should ask for
 * `image/jpeg`, where the size saving is worth the loss — and must then store it under that format,
 * not the source file's own extension, or they declare one format and store another.
 * `canvasOptions` go to cropper.js's `getCroppedCanvas`, e.g. `{ maxWidth, maxHeight }` to shrink it.
 */
const getCroppedImageUrl = (cropper, type = 'image/png', quality, canvasOptions) => cropper
  ?.getCroppedCanvas(canvasOptions)
  ?.toDataURL(type, quality);

export {
  getCroppedImageUrl,
};
